import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookWb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M54.2001 57.9001H6.8001C4.4601 57.9001 2.6001 56.0401 2.6001 53.7001V6.3001C2.6001 3.9601 4.4601 2.1001 6.8001 2.1001H54.2001C56.5401 2.1001 58.4001 3.9601 58.4001 6.3001V53.7001C58.4001 56.0401 56.5401 57.9001 54.2001 57.9001ZM6.8001 2.7001C4.8201 2.7001 3.2001 4.3201 3.2001 6.3001V53.7001C3.2001 55.6801 4.8201 57.3001 6.8001 57.3001H54.2001C56.1801 57.3001 57.8001 55.6801 57.8001 53.7001V6.3001C57.8001 4.3201 56.1801 2.7001 54.2001 2.7001H6.8001Z",
		fill: "#3F3F3F"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M26.42 30.4199V45.2399C26.42 45.4799 26.6 45.5999 26.78 45.5999H32.3C32.54 45.5999 32.66 45.4199 32.66 45.2399V30.1799H36.62C36.8 30.1799 36.98 29.9999 36.98 29.8199L37.34 25.2599C37.34 25.0199 37.16 24.8399 36.98 24.8399H32.6V21.5999C32.6 20.8199 33.2 20.2199 33.98 20.2199H37.1C37.34 20.2199 37.46 20.0399 37.46 19.8599V15.2999C37.46 15.0599 37.28 14.9399 37.1 14.9399H31.88C28.82 14.9399 26.36 17.3999 26.36 20.4599V24.8399H23.6C23.36 24.8399 23.24 25.0199 23.24 25.1999V29.7599C23.24 29.9999 23.42 30.1199 23.6 30.1199H26.36V30.4199H26.42Z",
		fill: "#3F3F3F"
	})]
});
export default SvgFacebookWb;
